export default "__VITE_ASSET__H398KRLr__"